module.exports = __webpack_public_path__ + "static/media/about.de9e2afe.png";